import { Avatar } from "antd";
import { AiOutlineUser } from "react-icons/ai";

export const UserAvatar = ({
  backgroundColor = "random",
  label,
  size,
  src = label
    ? `https://ui-avatars.com/api/?background=${backgroundColor}&name=${label}`
    : "",
  onAvatarClick = () => {},
  shape = "circle",
}) => {
  return (
    <Avatar
      shape={shape}
      src={src}
      size={size}
      onClick={onAvatarClick}
      icon={<AiOutlineUser />}
    />
  );
};
